// src/pages/ExamUnionParentZone.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const ExamUnionParentZone = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLogged = authState?.isLogged || false;
  const userName = authState?.user?.name || "Warrior";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const quickLinks = [
    { label: "Buy Subscription", emoji: "💳", link: "/examunion-bookworld", color: "from-amber-500 to-yellow-500" },
    { label: "Practice Series", emoji: "🎯", link: "/examunion-practice", color: "from-emerald-500 to-cyan-500" },
    { label: "Practice PYQ", emoji: "📜", link: "/examunion-practice", color: "from-purple-500 to-pink-500" },
    { label: "AITS", emoji: "⚡", link: "/examunion-practice", color: "from-orange-500 to-red-500" },
    { label: "My Rank", emoji: "🏆", link: "/examunion-myrank", color: "from-yellow-400 to-amber-500" },
    { label: "ExamUnion Rankers", emoji: "🏆", link: "/examunion-rankers", color: "from-cyan-400 to-purple-500" },
  ];

  const allFeatures = [
    { label: "Join ExamUnion", emoji: "🤝", link: "/examunion-bookworld" },
    // { label: "Buy Subscription", emoji: "💳", link: "/examunion-bookworld" },
    { label: "Immersive Books", emoji: "📚", link: "/examunion-bookworld" },
    { label: "Digital Bookshelf", emoji: "🗂️", link: "/bookshelf" },
    { label: "Create Own Series", emoji: "🛠️", link: "/examunion-create" },
    { label: "Submit Question", emoji: "✍️", link: "/examunion-submitquest" },
    { label: "Deep Thinking", emoji: "🧠", link: "/fivewhys-analysis-home" },
    { label: "AI Counselling", emoji: "🤖", link: "/aicounselling" },
    { label: "Open Cloud Notebooks", emoji: "📒", link: "/opentextbook-home" },
    { label: "My Chronicles", emoji: "📔", link: "/life-chronicles-home" },
    { label: "ParentZone / MentorZone", emoji: "👨‍👩‍👧", link: "/examunion-mentorzone" },
    { label: "Applause", emoji: "👏", link: "/applause-hub-home" },
    { label: "POV", emoji: "🎥", link: "/povify-home" },
    { label: "Marketplace", emoji: "🛒", link: "/khareedo" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-950 via-black to-zinc-950 text-white font-sans overflow-x-hidden">
      {/* Modern Sticky Header */}
      <header className="sticky top-0 z-50 bg-black/90 backdrop-blur-xl border-b border-white/10 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-2xl flex items-center justify-center text-2xl shadow-lg shadow-emerald-500/30">
            🔬
          </div>
          <div>
            <div className="text-2xl font-bold tracking-tighter bg-gradient-to-r from-emerald-300 via-cyan-300 to-purple-300 bg-clip-text text-transparent">
              ExamUnion
            </div>
            <p className="text-[10px] text-emerald-400 -mt-1">Unite • Create • Conquer • Earn</p>
          </div>
        </div>

        <div className="flex items-center gap-4">
          {isLogged ? (
            <div className="hidden md:flex items-center gap-3">
              <div className="text-sm font-medium px-4 py-1.5 bg-white/5 rounded-full border border-white/10">
                Hi, {userName.split(" ")[0]}
              </div>
              <button
                onClick={handleLogout}
                className="px-5 py-2 bg-red-600 hover:bg-red-700 rounded-full text-sm font-medium transition-all active:scale-95"
              >
                Logout
              </button>
            </div>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="hidden md:block px-2 py-2 bg-white text-black rounded-md font-semibold hover:bg-emerald-400 hover:text-black transition-all"
            >
              Join Now
            </button>
          )}

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-1 w-11 h-11 flex items-center justify-center text-xl text-emerald-300"
          >
            {isMobileMenuOpen ? "✕" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-zinc-900 border-b border-white/10 px-5 py-6 animate-fadeIn">
          {isLogged ? (
            <div className="flex flex-col gap-4 items-center">
              <p className="text-lg font-medium">Welcome, {userName}</p>
              <button onClick={handleLogout} className="w-full py-3 bg-red-600 rounded-2xl font-medium">
                Logout
              </button>
            </div>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-full py-3 bg-white text-black rounded-2xl font-semibold"
            >
              Login / Sign Up
            </button>
          )}
        </div>
      )}

      {/* 🔥 Your Cyan Navigation Bar - Now Beautiful & Mobile-First */}
      <div className="bg-gradient-to-r from-cyan-700 via-cyan-600 to-teal-600 text-white text-sm py-3 shadow-inner">
        <div className="px-2 flex flex-wrap justify-center gap-x-1 gap-y-1">
          <a href="/examUnion-about" className="hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            🧠 <span>About</span>
          </a>
          <Link to="/examunion-practice" className="hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            ⚡ <span>Live AITS</span>
          </Link>
          <a href="/examunion-rankers" className="hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            🏆 <span>Rankings</span>
          </a>
          <a href="/edutube" className="hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            🎥 <span>eduTube</span>
          </a>
          <a href="/orderflow-earning-estimator" className="hover:text-yellow-200 transition-colors flex items-center gap-1.5">
            💰 <span>Pocket Money</span>
          </a>
        </div>
      </div>

      {/* Hero Banner */}
      <div className="relative h-32 lg:h-40 flex items-center justify-center overflow-hidden bg-black">
        <div className="absolute inset-0 bg-[radial-gradient(at_center,#22d3ee_0%,transparent_70%)] opacity-20"></div>
        <div className="text-center px-6 z-10">
          <h1 className="text-xl lg:text-2xl font-black tracking-tighter mb-3">
            Crack It. Together.
          </h1>
          <p className="text-emerald-300 text-sm lg:text-lg max-w-xs mx-auto">
            JEE • NEET • UPSC • UGC NET<br />Your all-in-one battle arena
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-400 to-transparent"></div>
      </div>

      {/* Quick Access Cards */}
      <div className="px-4 mt-2 relative z-10">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-3">
          {quickLinks.map((item, idx) => (
            <button
              key={idx}
              onClick={() => navigate(item.link)}
              className={`group bg-zinc-900 hover:bg-zinc-800 border border-white/10 rounded-3xl p-5 transition-all active:scale-[0.97] flex flex-col items-center gap-1 shadow-xl shadow-black/50`}
            >
              <div className={`w-10 h-10 lg:w-14 lg:h-14 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-lg lg:text-2xl transition-transform group-active:rotate-12`}>
                {item.emoji}
              </div>
              <p className="text-gray-300 text-xs lg:text-sm font-semibold text-center leading-tight">{item.label}</p>
            </button>
          ))}
        </div>
      </div>

      {/* All Features Grid */}
      <div className="px-4 pt-4 pb-10">
        <div className="flex items-center justify-between mb-6 px-1">
          <h2 className="text-gray-300 text-xl lg:text-2xl font-bold tracking-tight">Explore Everything</h2>
          <div className="text-xs lg:text-sm uppercase tracking-widest text-emerald-400">Swipe • Tap • Grow</div>
        </div>

        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2">
          {allFeatures.map((feature, index) => (
            <button
              key={index}
              onClick={() => navigate(feature.link)}
              className="group bg-zinc-900/80 hover:bg-zinc-800 border border-white/5 hover:border-emerald-500/30 rounded-3xl p-5 transition-all duration-300 active:scale-95 flex flex-col items-center text-center gap-1 shadow-inner"
            >
              <div className="w-10 h-10 lg:w-14 lg:h-14 rounded-xl text-lg lg:text-2xl transition-transform group-hover:scale-110 group-active:rotate-6">
                {feature.emoji}
              </div>
              <p className="font-medium text-xs lg:text-sm leading-tight text-emerald-100 group-hover:text-white">
                {feature.label}
              </p>
            </button>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-black border-t border-white/10 py-8 px-4 text-center text-xs text-zinc-400">
        <div className="max-w-md mx-auto">
          © 2026 ExamUnion • Built for fighters who refuse to settle.<br />
          <div className="flex justify-center gap-6 mt-6 text-sm">
            <Link to="/about-us" className="hover:text-emerald-400 transition">About</Link>
            <Link to="/privacy-policy" className="hover:text-emerald-400 transition">Privacy</Link>
            <Link to="/terms-of-use" className="hover:text-emerald-400 transition">Terms</Link>
            <Link to="/contact-us" className="hover:text-emerald-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ExamUnionParentZone;